import React from 'react';
import ReportItem from "./ReportItem";
import '../reports/ReportsPage.css'
const ReportsList = ({ reports, onReportUpdated}) => {
    return (
        <div>
            <table className='table table-bordered'>
                <thead className='thead-light'>
                <tr>
                    <th className='text'>Текст</th>
                    <th className='date'>Дата Обращения</th>
                    <th className='email'>Почта</th>
                    <th className='platform'>Платформа</th>
                    <th className='status'>Статус</th>
                    <th className='actions'>Действие</th>
                </tr>
                </thead>
                <tbody>
                {reports.map(reportItem => (
                    <ReportItem
                        key={reportItem.id}
                        report={reportItem}
                        onReportUpdated={onReportUpdated}
                    />
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default ReportsList;